/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerssizea53Inputs */

const en_placeflyerssizea53 = /** @type {(inputs: Placeflyerssizea53Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

const de_placeflyerssizea53 = /** @type {(inputs: Placeflyerssizea53Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

/**
* | output |
* | --- |
* | "A5" |
*
* @param {Placeflyerssizea53Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerssizea53 = /** @type {((inputs?: Placeflyerssizea53Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerssizea53Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerssizea53(inputs)
	return de_placeflyerssizea53(inputs)
});
export { placeflyerssizea53 as "placeFlyersSizeA5" }